import { IFileType } from "@zappar/zw-api-client";
import { ZapworksAsset } from "./base";
import { MediaType } from "../../../types";

export class ImageAsset extends ZapworksAsset<IFileType.Image> {
  // private _imageUrlForCard?: string;

  getMediaType() {
    return MediaType.Image;
  }

  async getImageUrlForCard(size?: { width: number; height?: number }, useCache = true) {
    // if (this._imageUrlForCard) {
    //   return this._imageUrlForCard;
    // }
    const baseUrl = await this.getFileUrl(useCache);
    // const width = size?.width || 256;
    // const height = size?.height || width;
    // const req = await fetch(`${baseUrl}/img.r.w${width}.h${height}.png`);
    // const blob = await req.blob();
    // this._imageUrlForCard = URL.createObjectURL(blob);
    // return this._imageUrlForCard;
    return this.addPathToFileUrl(new URL(baseUrl), 'img').toString();
  }

  async getPreviewUrl(size?: { width: number; height?: number }, useCache = true) {
    return this.getImageUrlForCard(size, true);
  }

  async getDownloadUrl(useCache = true) {
    const baseUrl = await this.getFileUrl(useCache);
    return this.addPathToFileUrl(new URL(baseUrl), 'img').toString();
  }
}
